import { useUserSync } from '@/hooks/useUserSync';

interface UserSyncProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that syncs Clerk user to Supabase
 * Should be placed inside ClerkProvider but around the rest of the app
 */
export function UserSyncProvider({ children }: UserSyncProviderProps) {
  useUserSync();
  return <>{children}</>;
}

export default UserSyncProvider;
